/* Fransk katalog for locale-bank-archive-filter-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'bank.archive.filter.postingType': 'Type d\'écriture',
  'bank.archive.filter.purchase': 'Achat',
  'bank.archive.filter.otherSale': 'Autre vente',
  'bank.archive.filter.payment': 'Paiement',
  'bank.archive.filter.manualPosting': 'Écriture libre',
  'bank.archive.filter.bankPosting': 'Écriture bancaire',
  'bank.archive.filter.publicPayment': 'Paie et charges',
  'bank.archive.filter.ignored': 'Ligne bancaire ignorée',
  'bank.archive.filter.documentation': 'Documentation',
  'bank.archive.filter.missingAttachment': 'Justificatif manquant',
  'bank.archive.filter.hasAttachment': 'Avec justificatif',
  'bank.archive.sort.label': 'Trier les écritures',
  'bank.archive.sort.statementOrder': 'Ordre du relevé bancaire',
  'bank.archive.sort.dateDesc': 'Date : plus récentes d\'abord',
  'bank.archive.sort.dateAsc': 'Date : plus anciennes d\'abord',
  'bank.archive.sort.amountDesc': 'Montant : plus élevé d\'abord',
  'bank.archive.sort.amountAsc': 'Montant : plus faible d\'abord',
});
